module.exports = __webpack_public_path__ + "img/NurEinBischenRegen.10b645c9.jpg";